
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.95 22.375L18 19.425v2.225h-2V16h5.65v2H19.4l2.95 2.95-1.4 1.425zM12 22a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 012 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 012.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0112 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 013.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0122 12a10.054 10.054 0 01-.2 2h-2.05a8.048 8.048 0 000-4h-3.4a13.592 13.592 0 01.15 2 13.366 13.366 0 01-.15 2h-2a13.592 13.592 0 00.15-2 13.366 13.366 0 00-.15-2h-4.7a13.592 13.592 0 00-.15 2 13.366 13.366 0 00.15 2H13v2h-2.9a12.404 12.404 0 001.9 3.95c.333 0 .667-.02 1-.063.333-.041.667-.079 1-.112v2.05c-.333.033-.667.07-1 .113A8.048 8.048 0 0112 22zm-7.75-8h3.4a13.592 13.592 0 01-.15-2 13.366 13.366 0 01.15-2h-3.4a8.434 8.434 0 00-.188 1 8.054 8.054 0 00.188 3zm.85-6h2.95A15.204 15.204 0 019.4 4.45c-.917.3-1.742.754-2.475 1.362A7.866 7.866 0 005.1 8zm4.3 11.55A15.204 15.204 0 018.05 16H5.1a7.865 7.865 0 001.825 2.188A7.489 7.489 0 009.4 19.55zM10.1 8h3.8A12.402 12.402 0 0012 4.05 12.402 12.402 0 0010.1 8zm5.85 0h2.95a7.866 7.866 0 00-1.825-2.188A7.488 7.488 0 0014.6 4.45 15.204 15.204 0 0115.95 8z","fill":"currentColor"}})])
          )
        }
      }
    